// extracted by mini-css-extract-plugin
export default {"container":"MyEmployees_container__NkDOq","filters":"MyEmployees_filters__pXA2f","table":"MyEmployees_table__dHDuo"};